import { createSelector } from 'reselect';

type SagaState = {
  loadingActions: string[];
  loadedActions: {
    [key: string]: {
      loaded: boolean;
      [key: string]: any;
    };
  };
};

type RootState = {
  saga: SagaState;
};

export const isLoading = (actions: string[]) =>
  createSelector(
    (state: RootState) => state.saga.loadingActions,
    (loadingActions: string[]): boolean =>
      (loadingActions || []).some(item => actions.includes(item))
  );

export const isLoaded = (actions: string[]) =>
  createSelector(
    (state: RootState) => state.saga.loadedActions,
    (loadedActions): boolean =>
      actions.every(
        action => loadedActions[action] && loadedActions[action].loaded
      )
  );

export const sagaDataLoaded = (action: string) => (state: RootState) =>
  state.saga.loadedActions[action];

export const getLoadedActions = (state: RootState) => state.saga.loadedActions;
